<template>
  <div>
    <Header></Header>
    <div class="background">
      <div class="read">
        <div class="banner">
          <el-carousel
            class="banner-left"
            trigger="click"
            ref="carousel"
            indicator-position="none"
            height="340px"
            :autoplay="false"
          >
            <el-carousel-item v-for="(banner,index) in banner1" :key="index">
              <a v-if="banner.type==5" :href="banner.url">
                <img :src="banner.pc_image" alt />
                <div class="title">
                  <p>{{banner.name}}</p>
                </div>
              </a>
              <router-link
                :to="{path:'/details',query: {id: banner.course_id}}"
                v-if="banner.type==1"
              >
                <img :src="banner.pc_image" alt />
                <div class="title">
                  <p>{{banner.name}}</p>
                </div>
              </router-link>
              <router-link :to="{path:'/huodong',query: {id:banner.id}}" v-if="banner.type==2">
                <img :src="banner.pc_image" alt />
                <div class="title">
                  <p>{{banner.name}}</p>
                </div>
              </router-link>
              <router-link
                :to="{path:'/advi_details',query: {id: banner.consultteacher_id}}"
                v-if="banner.type==3"
              >
                <img :src="banner.pc_image" alt />
                <div class="title">
                  <p>{{banner.name}}</p>
                </div>
              </router-link>
              <router-link
                :to="{path:'/evalu_details',query: {id: banner.appraisal_id}}"
                v-if="banner.type==4"
              >
                <img :src="banner.pc_image" alt />
                <div class="title">
                  <p>{{banner.name}}</p>
                </div>
              </router-link>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="body">
          <div class="left">
            <div class="tabs">
              <ul>
                <li
                  v-for="(tab,index) in tabs"
                  :key="index"
                  @click="toggle(index,tab.id)"
                  :class="{active:active==index}"
                >{{tab.name}}</li>
              </ul>
            </div>
            <div class="cont">
              <div>
                <div class="tab">
                  <div
                    @click="goreaddetails(m.id)"
                    class="list"
                    v-for="(m,index) in tabMain"
                    :key="index"
                  >
                    <div class="left">
                      <div class="title">{{m.name}}</div>
                      <div
                        class="cont"
                      >{{m.intro}}</div>
                      <div class="bot">
                        <img src="../../assets/img/pe.png" alt />
                        <span class="name">{{m.source}}</span>
                        <img src="../../assets/img/dz.png" alt />
                        <span class="number">{{m.like_count}}</span>
                        <img src="../../assets/img/zf.png" alt />
                        <span class="number">{{m.share_count}}</span>
                      </div>
                    </div>
                    <img class="img" :src="m.image" alt />
                  </div>
                  <div class="btn" @click="btn()">加载更多</div>
                </div>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="r-cont">
              <div class="related">名师推荐</div>
              <div
                class="list"
                @click="gotdetails(top_teacher.id)"
                v-for="(top_teacher,index) in top_teachers"
                :key="index"
              >
                <img :src="top_teacher.avatar" alt />
                <div>
                  <div class="name">{{top_teacher.nickname}}</div>
                  <div class="lect">{{top_teacher.the_title}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Login v-show="popup==1"></Login>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../header";
import Footer from "../footer";
import Login from "../popup/login";

export default {
  name: "read",
  data() {
    return {
      active: 0,
      currentView: "",
      tabs: [],
      tabMain: [],
      popup: "",
      banner1: [],
      top_teachers: [],
      page: "1", //默认页数
      page_count: "3", //默认请求数量
      arr: [],
      cont: "3"
    };
  },
  methods: {
    // banner
    async banner() {
      await this.$service.home
        .banner({ site: "2" })
        .then(res => {
          console.log(res);
          if (res.data.code == 200) {
            this.banner1 = res.data.content;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 课程分类
    async article_type() {
      await this.$service.home
        .article_type({})
        .then(res => {
          if (res.data.code == 200) {
            this.tabs = res.data.content;
            // 默认
            this.currentView = res.data.content[0].id;
            this.toggle();
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 名师推荐（PC）
    async top_teacher() {
      await this.$service.home
        .top_teacher({})
        .then(res => {
          if (res.data.code == 200) {
            this.top_teachers = res.data.content;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 阅读列表
    async toggle(i, v) {
      if (i == undefined) {
        this.active = 0;
      } else {
        this.active = i;
        this.currentView = v;
      }
      this.page = 1;
      this.arr = [];
      this.cont = 3;
      var id = this.currentView;
      await this.$service.home
        .article_list({
          type_id: id,
          page: this.page,
          page_count: this.page_count
        })
        .then(res => {
          console.log(res)
          if (res.data.code == 200) {
            res.data.content.list.map(i => {
              this.arr.push(i);
            });
            this.tabMain = res.data.content.list;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    async btn() {
      this.page++;
      var id = this.currentView;
      console.log(this.cont);
      if (this.page_count <= this.cont) {
        await this.$service.home
          .article_list({
            type_id: id,
            page: this.page,
            page_count: this.page_count
          })
          .then(res => {
            console.log(res.data.content.list.length);
            this.cont = res.data.content.list.length;
            if (res.data.code == 200) {
              res.data.content.list.map(i => {
                this.arr.push(i);
                this.tabMain = this.arr;
              });
            }
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        this.$confirm("没有更多了哦~")
          .then(_ => {
            done();
          })
          .catch(_ => {});
      }
    },
    // 跳转详情
    goreaddetails(id) {
      this.$router.push({
        path: "/read_details",
        query: {
          id: id
        }
      });
    },
    // 讲师跳转
    gotdetails(id) {
      this.$router.push({
        path: "/topic_details",
        query: {
          id: id
        }
      });
    }
  },
  components: {
    Header,
    Footer,
    Login
  },
  mounted() {
    this.article_type();
    this.banner();
    this.top_teacher();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.background {
  background-color: #f9f9f9;
  padding-bottom: 20px;
}
.background .read {
  width: 1200px;
  margin: 0 auto;
}
.background .read .banner img {
  width: 1200px;
  height: 340px;
}
.background .read .banner {
  position: relative;
  margin-bottom: 14px;
}
.background .read .banner .title {
  width: 1200px;
  height: 50px;
  background: rgba(0, 0, 0, 0.4);
  position: absolute;
  bottom: 1px;
  z-index: 999;
}
.background .read .banner .title p {
  font-size: 18px;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  margin-left: 16px;
}
.read .body {
  display: flex;
  justify-content: space-between;
}
.read .body .left {
  width: 860px;
  border-radius: 3px;
  border: 1px solid #fff;
}
.read .body .left .tabs {
  height: 58px;
  background: rgba(255, 255, 255, 1);
  border-radius: 3px;
  border: 1px solid rgba(237, 237, 237, 1);
  margin-bottom: 16px;
}
.read .body .left .tabs {
  width: 860px;
  background: rgba(255, 255, 255, 1);
  border-radius: 3px;
}
.read .body .left .tabs ul {
  display: flex;
  padding: 0;
}
.read .body .left .tabs ul li {
  width: 100px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
.read .body .left .tabs ul li.active {
  color: #1775ef;
}
.read .body .left .cont {
  background: rgba(255, 255, 255, 1);
  border-radius: 3px;
  border: 1px solid #fff;
}
.read .body .right {
  width: 324px;
  height: auto;
  background: rgba(255, 255, 255, 1);
  border-radius: 3px;
  border: 1px solid rgba(237, 237, 237, 1);
}
.read .body .right .r-cont {
  width: 282px;
  margin: 0 auto;
}
.read .body .right .r-cont .related {
  width: 280px;
  font-size: 16px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  border-left: 3px solid #1775ef;
  padding-left: 5px;
  margin: 0 auto;
  margin-bottom: 16px;
  margin-top: 20px;
}
.read .body .right .r-cont .list {
  border-bottom: 1px solid #ededed;
  height: 65px;
  display: flex;
  margin-bottom: 16px;
}
.read .body .right .r-cont .list img {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  margin-right: 20px;
}
.read .body .right .r-cont .list .name {
  font-size: 16px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 27px;
}
.read .body .right .r-cont .list .lect {
  font-size: 12px;
  font-weight: 500;
  color: rgba(136, 136, 136, 1);
  line-height: 22px;
}

.tab {
  width: 820px;
  margin: 0 auto;
  margin-top: 20px;
}
.tab .list {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #e6e6e6;
  margin-bottom: 20px;
}
.tab .list .left {
  width: 625px;
}
.tab .list .left .title {
  font-size: 18px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 32px;
  margin-bottom: 4px;
}
.tab .list .left .cont {
  font-size: 14px;
  font-weight: 500;
  color: rgba(136, 136, 136, 1);
  line-height: 26px;
  margin-bottom: 8px;
}
.tab .list .left .bot {
  margin-bottom: 20px;
}
.tab .list .left .bot .name {
  color: #1775ef;
  font-size: 12px;
  font-weight: 500;
}
.tab .list .left .bot .number {
  font-size: 12px;
  font-weight: 500;
  color: rgba(136, 136, 136, 1);
}
.tab .list .img {
  width: 166px;
  height: 116px;
  border-radius: 10px;
}
.tab .btn {
  width: 126px;
  height: 40px;
  border-radius: 35px;
  border: 1px solid rgba(23, 117, 239, 1);
  font-weight: 500;
  color: rgba(23, 117, 239, 1);
  line-height: 40px;
  letter-spacing: 1px;
  margin: 0 auto;
  text-align: center;
  margin-bottom: 23px;
}
</style>



// WEBPACK FOOTER //
// src/components/reading/reading.vue